<template>
  <v-card class="pwc-event-item" @click="goDetail(event)">
    <v-img
      class="pwc-event-cover"
      :src="event.coverUrl"
    />
    <div>
      <v-card-title class="pwc-event-title">
        <span>{{ event.eventName }}</span><br>
      </v-card-title>
      <v-card-title class="pwc-event-content">
        <span>主题：{{ event.subject }}</span>
        <span>时间：{{ event.dateForPrint }}</span>
        <span>地点：{{ event.location }}</span>
      </v-card-title>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    event: {
      type: Object,
      default: () => { return { } }
    },
    goDetail: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-event-item {
    display: flex;
    margin-top: 12px;
    margin-bottom: 24px;
    cursor: pointer;
    .pwc-event-cover {
        width: 200px;
        flex-grow: 0;
    }
    .pwc-event-title {
        span {
            font-weight: bold;
            font-size: 16px;
        }
    }
    .pwc-event-content {
        >span {
            width: 100%;
            display: block;
            margin-top: 6px;
            margin-bottom: 6px;
        }
    }
}
</style>
